"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ChangeIdis2goLinkRequestSchema () {
        return ChangeIdis2goLinkRequestSchema;
    },
    get ChangeIdis2goLinkResponseSchema () {
        return ChangeIdis2goLinkResponseSchema;
    },
    get CreateIdis2goLinkRequestSchema () {
        return CreateIdis2goLinkRequestSchema;
    },
    get CreateIdis2goLinkResponseSchema () {
        return CreateIdis2goLinkResponseSchema;
    },
    get IDIS2GO_BACKFILL_STATUSES () {
        return IDIS2GO_BACKFILL_STATUSES;
    },
    get IDIS2GO_LINK_ERROR_CODES () {
        return IDIS2GO_LINK_ERROR_CODES;
    },
    get Idis2goCustomerListResponseSchema () {
        return Idis2goCustomerListResponseSchema;
    },
    get Idis2goCustomerSchema () {
        return Idis2goCustomerSchema;
    },
    get Idis2goDiscoveryRunResponseSchema () {
        return Idis2goDiscoveryRunResponseSchema;
    },
    get Idis2goLinkBackfillSchema () {
        return Idis2goLinkBackfillSchema;
    },
    get Idis2goLinkListResponseSchema () {
        return Idis2goLinkListResponseSchema;
    },
    get Idis2goLinkSchema () {
        return Idis2goLinkSchema;
    },
    get Idis2goLinkStartRequestSchema () {
        return Idis2goLinkStartRequestSchema;
    },
    get Idis2goLinkStartSchema () {
        return Idis2goLinkStartSchema;
    },
    get Idis2goLinkedClinicSchema () {
        return Idis2goLinkedClinicSchema;
    }
});
const _zod = require("zod");
const IDIS2GO_LINK_ERROR_CODES = {
    /** `409`: another clinic holds this customer. The answer never says which. */ customerAlreadyLinked: 'CUSTOMER_ALREADY_LINKED',
    /** `400`: `confirmTenantSlug` is not the clinic's slug. */ tenantSlugMismatch: 'TENANT_SLUG_MISMATCH',
    /** `400`: the customer is not in the discovered list. Refresh the list first. */ customerNotDiscovered: 'IDIS2GO_CUSTOMER_NOT_DISCOVERED',
    /**
   * `400`: the customer is in the list, but discovery hasn't read its name
   * yet (ingest only counted its skipped visits). Refresh the list first, so
   * the confirmation shows a real name.
   */ customerNameUnknown: 'IDIS2GO_CUSTOMER_NAME_UNKNOWN',
    /** `400`: "from now" before ingest's first run: there is no "now" yet. */ ingestNotStarted: 'IDIS2GO_INGEST_NOT_STARTED',
    /** `409`: the link is already on with another start. Unlink it first. */ startLocked: 'IDIS2GO_LINK_START_LOCKED',
    /** `409`: the tenant is the platform, or not marked as a clinic. */ notAClinic: 'IDIS2GO_LINK_NOT_A_CLINIC'
};
const IDIS2GO_BACKFILL_STATUSES = [
    'waiting',
    'running',
    'done',
    'cancelled'
];
/** IDIS2GO result ids are bigints; this keeps them within an exact JS number. */ const RESULT_ID = _zod.z.number().int().min(1).max(Number.MAX_SAFE_INTEGER);
/** A real calendar day, `YYYY-MM-DD`. Refuses 2026-02-30 and the like. */ const CALENDAR_DATE = _zod.z.string().regex(/^\d{4}-\d{2}-\d{2}$/).refine((value)=>{
    const parsed = new Date(`${value}T00:00:00Z`);
    return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
}, 'must be a real date');
const Idis2goLinkedClinicSchema = _zod.z.object({
    tenantId: _zod.z.uuid(),
    name: _zod.z.string(),
    linkEnabled: _zod.z.boolean()
}).strict();
const Idis2goCustomerSchema = _zod.z.object({
    customerUuid: _zod.z.uuid(),
    name: _zod.z.string(),
    kitSerials: _zod.z.array(_zod.z.string()),
    /**
     * Visits ingest skipped because no clinic had an enabled link, over the
     * customer's whole life in EMRA. It never goes down, even once linked.
     * A count only.
     */ skippedVisits: _zod.z.number().int().min(0),
    firstSeenAt: _zod.z.iso.datetime(),
    lastSeenAt: _zod.z.iso.datetime(),
    /** Null when no clinic has a link to it, enabled or not. */ linkedClinic: Idis2goLinkedClinicSchema.nullable()
}).strict();
const Idis2goCustomerListResponseSchema = _zod.z.object({
    items: _zod.z.array(Idis2goCustomerSchema)
}).strict();
const Idis2goDiscoveryRunResponseSchema = _zod.z.object({
    status: _zod.z.enum([
        'queued',
        'already_queued'
    ])
}).strict();
const Idis2goLinkStartSchema = _zod.z.discriminatedUnion('kind', [
    _zod.z.object({
        kind: _zod.z.literal('resultId'),
        resultId: RESULT_ID.optional()
    }).strict(),
    _zod.z.object({
        kind: _zod.z.literal('date'),
        date: CALENDAR_DATE
    }).strict()
]);
const Idis2goLinkStartRequestSchema = _zod.z.discriminatedUnion('kind', [
    _zod.z.object({
        kind: _zod.z.literal('now')
    }).strict(),
    _zod.z.object({
        kind: _zod.z.literal('resultId'),
        resultId: RESULT_ID
    }).strict(),
    _zod.z.object({
        kind: _zod.z.literal('date'),
        date: CALENDAR_DATE
    }).strict()
]);
const Idis2goLinkBackfillSchema = _zod.z.object({
    status: _zod.z.enum(IDIS2GO_BACKFILL_STATUSES),
    /** How much of its range it has read, 0 to 100. Null while waiting. */ readPercent: _zod.z.number().int().min(0).max(100).nullable(),
    /** Visits it stored. A count only. */ storedVisits: _zod.z.number().int().min(0),
    startedAt: _zod.z.iso.datetime().nullable(),
    finishedAt: _zod.z.iso.datetime().nullable()
}).strict();
const Idis2goLinkSchema = _zod.z.object({
    /** The link id, the `:linkId` of the routes. */ id: _zod.z.uuid(),
    customerUuid: _zod.z.uuid(),
    /** The customer's name when the link was made or re-enabled. Null when unknown. */ customerName: _zod.z.string().nullable(),
    enabled: _zod.z.boolean(),
    /** Where ingest starts. Null for an old link made with no start point. */ from: Idis2goLinkStartSchema.nullable(),
    createdAt: _zod.z.iso.datetime(),
    updatedAt: _zod.z.iso.datetime(),
    /** Null when the link never had a backfill and isn't waiting for one. */ backfill: Idis2goLinkBackfillSchema.nullable()
}).strict();
const Idis2goLinkListResponseSchema = _zod.z.object({
    items: _zod.z.array(Idis2goLinkSchema)
}).strict();
const CreateIdis2goLinkRequestSchema = _zod.z.object({
    customerUuid: _zod.z.uuid(),
    from: Idis2goLinkStartRequestSchema,
    confirmTenantSlug: _zod.z.string().trim().min(1).max(100)
}).strict();
const CreateIdis2goLinkResponseSchema = _zod.z.object({
    link: Idis2goLinkSchema,
    outcome: _zod.z.enum([
        'linked',
        're_enabled',
        'unchanged'
    ])
}).strict();
const ChangeIdis2goLinkRequestSchema = _zod.z.object({
    enabled: _zod.z.literal(false)
}).strict();
const ChangeIdis2goLinkResponseSchema = _zod.z.object({
    link: Idis2goLinkSchema
}).strict();
